/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Artifacts_Start_Chat_LimitInputs */



/**
* | output |
* | --- |
* | "You can start a chat with at most {max} artifacts at once." |
*
* @param {Artifacts_Start_Chat_LimitInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifacts_start_chat_limit = /** @type {((inputs: Artifacts_Start_Chat_LimitInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifacts_Start_Chat_LimitInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Du kannst einen Chat mit höchstens ${i?.max} Artefakten gleichzeitig starten.`)
	return /** @type {LocalizedString} */ (`You can start a chat with at most ${i?.max} artifacts at once.`)
});